import * as React from "react";
import { SVGProps } from "react";
const SvgUy = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 512 336"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none">
      <path
        d="M503.172.276H8.828A8.828 8.828 0 0 0 0 9.103v317.793a8.829 8.829 0 0 0 8.828 8.828h494.345a8.829 8.829 0 0 0 8.828-8.828V9.103a8.83 8.83 0 0 0-8.829-8.827z"
        fill="#F5F5F5"
      />
      <path fill="#4173CD" d="M185.379 37.55H512v37.272H185.379z" />
      <path fill="#F5F5F5" d="M0 74.825h512v37.272H0z" />
      <path fill="#4173CD" d="M185.379 112.088H512v37.272H185.379z" />
      <path fill="#F5F5F5" d="M0 149.363h512v37.272H0z" />
      <path fill="#4173CD" d="M0 186.637h512v37.272H0z" />
      <path fill="#F5F5F5" d="M0 223.912h512v37.272H0z" />
      <path fill="#4173CD" d="M0 261.175h512v37.272H0z" />
      <path fill="#FFE15A" d="m63.976 23.642 14.767 68.333 23.107-9.572z" />
      <path fill="#FFCD5A" d="m63.976 23.642 26.32 63.547-11.553 4.786z" />
      <path fill="#FFE15A" d="m121.404 162.289-14.768-68.333-23.107 9.572z" />
      <path fill="#FFCD5A" d="M121.404 162.289 95.083 98.742l11.553-4.786z" />
      <path fill="#FFE15A" d="M162.013 64.252 93.681 79.019l9.571 23.107z" />
      <path fill="#FFCD5A" d="m162.013 64.252-63.547 26.32-4.785-11.553z" />
      <path fill="#FFE15A" d="m23.367 121.679 68.332-14.767-9.572-23.107z" />
      <path fill="#FFCD5A" d="m23.367 121.679 63.546-26.32 4.786 11.553z" />
      <path fill="#FFE15A" d="M121.404 23.642 83.529 82.403l23.107 9.572z" />
      <path fill="#FFCD5A" d="M121.404 23.642 95.083 87.189l-11.554-4.786z" />
      <path fill="#FFE15A" d="m63.976 162.289 37.874-58.761-23.107-9.572z" />
      <path fill="#FFCD5A" d="m63.976 162.289 26.32-63.547 11.554 4.786z" />
      <path fill="#FFE15A" d="m162.013 121.679-58.761-37.874-9.571 23.107z" />
      <path fill="#FFCD5A" d="m162.013 121.679-63.547-26.32 4.786-11.554z" />
      <path fill="#FFE15A" d="m23.367 64.252 58.76 37.874 9.572-23.107z" />
      <path fill="#FFCD5A" d="m23.367 64.252 63.546 26.32-4.786 11.554z" />
      <path fill="#FFE15A" d="M92.69 17.931 80.184 86.712h25.011z" />
      <path fill="#FFCD5A" d="M92.69 17.931v68.781H80.184z" />
      <path fill="#FFE15A" d="m92.69 168 12.505-68.781H80.184z" />
      <path fill="#FFCD5A" d="M92.69 168V99.219h12.505z" />
      <path fill="#FFE15A" d="M167.724 92.966 98.943 80.46v25.011z" />
      <path fill="#FFCD5A" d="M167.724 92.966H98.943V80.46z" />
      <path fill="#FFE15A" d="m17.655 92.966 68.781 12.505V80.46z" />
      <path fill="#FFCD5A" d="M17.655 92.966h68.781v12.505z" />
      <path fill="#FFE15A" d="M145.747 39.908 88.268 79.701l17.686 17.686z" />
      <path fill="#FFCD5A" d="M145.747 39.908 97.111 88.544l-8.843-8.843z" />
      <path fill="#FFE15A" d="m39.633 146.023 57.478-39.793-17.686-17.686z" />
      <path fill="#FFCD5A" d="m39.633 146.023 48.635-48.636 8.843 8.843z" />
      <path fill="#FFE15A" d="m145.747 146.023-39.793-57.479-17.686 17.686z" />
      <path fill="#FFCD5A" d="M145.747 146.023 97.111 97.387l8.843-8.843z" />
      <path fill="#FFE15A" d="m39.633 39.908 39.792 57.479 17.686-17.686z" />
      <path fill="#FFCD5A" d="m39.633 39.908 48.635 48.636-8.843 8.843z" />
      <circle fill="#FFE15A" cx={92.69} cy={92.966} r={25.012} />
    </g>
  </svg>
);
export default SvgUy;
